export default __webpack_public_path__ + "static/media/opensea_button_white.3cba0098.png";